module.exports = __webpack_public_path__ + "media/images/flags/4x3/png-abc81ff99e566b446f92ac66ce8c6f30.svg";